module.exports = __webpack_public_path__ + "static/media/logo.cd050fc2.png";